import { RemoteInternshipLocation } from 'data/usecases';
import { GetInternshipLocationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlInternshipLocation } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetInternshipLocation =
  (): GetInternshipLocationUseCaseInterface =>
    new RemoteInternshipLocation(
      makeApiUrlInternshipLocation(),
      makeAxiosHttpClient(),
    );
